import { datadogRum } from '@datadog/browser-rum';
import { useQueryCache } from '@pinia/colada';

import { useAvailabilityStore } from '@tallo/investor/availability';
import { useInvestorStore } from '@tallo/investor/investor';
import { useUserStore } from '@tallo/user';

class AppInitService {
  initApp(): void {
    const availabilityStore = useAvailabilityStore();

    this.loadAndTrackUser();
    availabilityStore.loadAvailability();
  }

  loadAndTrackUser(): void {
    const investorStore = useInvestorStore();

    investorStore.load().then(() => {
      if (investorStore.investor?.user) {
        const user = investorStore.investor.user;
        datadogRum.setUser({
          id: user.id,
          email: user.email,
          name: user.name,
        });
      }
    });
  }

  reset() {
    const queryCache = useQueryCache();
    const userStore = useUserStore();
    const availabilityStore = useAvailabilityStore();

    userStore.$reset();
    availabilityStore.$reset();

    queryCache.getEntries().forEach((entry) => {
      queryCache.invalidate(entry);
      queryCache.remove(entry);
    });
  }
}

export default new AppInitService();
